
import { useState } from "react"

import { Building2, Check, ChevronsDownUp, ChevronsUpDown } from "lucide-react"

import { Button } from "@ui/button"
import { Input } from "@ui/input"
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover"
import { useUserSession } from "@session/UserSession"

export function AccountSelection() {
    const { accounts, account, switchAccount } = useUserSession()

    const [open, setOpen] = useState(false)
    const [filterValue, setFilterValue] = useState("")

    const filteredOptions = accounts?.filter((account) =>
        account.name.toLowerCase().includes(filterValue.toLowerCase())
    )

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation()
        setFilterValue(e.target.value)
    }

    const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation()
    }

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <div className='flex flex-row border gap-2 items-center justify-center cursor-pointer hover:bg-gray-200 rounded-md'>
                    <div className='border-r'>
                        <Building2 className='p-1' />
                    </div>
                    <div className='w-full text-sm font-light text-left text-primary truncate'>{account?.name}</div>
                    <div className='border-l'>
                        {
                            open
                                ? <ChevronsDownUp className="p-1 opacity-50" />
                                : <ChevronsUpDown className="p-1 opacity-50" />
                        }
                    </div>
                </div>
            </PopoverTrigger>
            <PopoverContent className="max-w-[300px] p-2 border shadow" align="start">
                {
                    accounts && accounts.length > 5 &&
                    <Input
                        placeholder="Search Organizations..."
                        value={filterValue}
                        onChange={handleInputChange}
                        onKeyDown={handleInputKeyDown}
                        onClick={(e) => e.stopPropagation()}
                        className='mb-2'
                    />
                }
                <div className='flex flex-col gap-2 max-h-[200px] overflow-y-auto'>
                    {
                        filteredOptions?.map((acc) => (
                            <Button
                                key={acc.id}
                                onClick={() => switchAccount(acc.id)}
                                variant="ghost"
                                className='flex flex-row items-center justify-between p-1'
                            >
                                <div className='text-sm truncate'>{acc.name}</div>
                                {acc.name === account?.name && <Check className="h-4 w-4" />}
                            </Button>
                        ))
                    }
                </div>
            </PopoverContent>
        </Popover>
    )
}